export function isNonUuidAssistantId(id: string): boolean {
  const uuid4Regex =
    /^asst_[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  const plainIdRegex = /^asst_[A-Za-z0-9]+$/;

  if (uuid4Regex.test(id)) {
    return false;
  }

  if (plainIdRegex.test(id)) {
    return true;
  }

  return false;
}
